// extracted by mini-css-extract-plugin
module.exports = {"header":"styles__header___1IKI1","aligned":"styles__aligned___2-zOB"};